import React from 'react'
import {Route} from 'react-router-dom'

import ParcelCarriers from './ParcelCarriers.js'
import ParcelProducts from './ParcelProducts.js'
import ParcelPreferences from './ParcelPreferences.js'
import ShippingRules from './ShippingRules.js'
import ParcelPrices from './ParcelPrices.js'
import ParcelProductCodes from './ParcelProductCodes.js'
import TrackTraceEmail from './TrackTraceEmail.js'
import CustomerSupport from './CustomerSupport.js'

class ParcelSettings extends React.Component {
    componentDidMount() {
        const {history} = this.props

        if (history.location.pathname === '/instellingen/zendingen' || history.location.pathname === '/instellingen/zendingen/') {
            history.push('/instellingen/zendingen/vervoerders')
        }
    }

    render() {
        const {reseller, carriers, onChange} = this.props

        return (
            <>
                <Route path='/instellingen/zendingen/vervoerders' render={() => <ParcelCarriers reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/verzendopties' render={() => <ParcelProducts reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/voorkeuren' render={() => <ParcelPreferences reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/verzendregels' render={() => <ShippingRules reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/tarieven' render={() => <ParcelPrices reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/productcodes' render={() => <ParcelProductCodes reseller={reseller} carriers={carriers} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/tracktraceemail' render={() => <TrackTraceEmail reseller={reseller} onChange={onChange} />} />
                <Route path='/instellingen/zendingen/meldingen' render={() => <CustomerSupport reseller={reseller} carriers={carriers} onChange={onChange} />} />
            </>
        )
    }
}

export default ParcelSettings
